define('controllers/404',['require','layout'],function(require) {
    'use strict';
    var layout = require('layout');
    return {
        load: function() {
            return layout.initStatic('/fe/templates/404').then(function() {
                $('[data-membersupportemail]').text(window.ServerData.Emails.MemberSupport);
                $('[data-membersupportphone]').text(window.ServerData.Phones.MemberSupportPhone);
            });
        },

        unload: $.noop
    };
});

